import type { CSSProperties } from 'react';
import type { Route } from '../App';
import { Icon, type IconName } from '../components/Icon';
import { useAllClients, useWorkspace, useWorkspaces } from '../data/store';
import { euro, shortDate } from '../data/helpers';

interface Props {
  onOpenClient: (id: string) => void;
  onGo: (r: Route) => void;
}

export function PartnersView({ onGo }: Props) {
  const { setCurrent } = useWorkspace();
  const clients = useAllClients();
  const workspaces = useWorkspaces();
  const enter = (id: string) => {
    setCurrent(id);
    onGo('clients');
  };

  const partnerWs = workspaces.filter((w) => !w.house);
  const partnerClients = clients.filter((c) => c.workspaceId !== 'risma');
  const partnerMrr = partnerClients.reduce((s, c) => s + c.mrr, 0);

  return (
    <div className="view">
      <div className="view-pad rs-stack">
        <div className="kpi-row">
          <Kpi icon="users" val={String(workspaces.length)} label="Spazi di lavoro" />
          <Kpi icon="building" val={String(partnerWs.length)} label="Partner" />
          <Kpi icon="list" val={String(partnerClients.length)} label="Clienti dei partner" />
          <Kpi icon="chart" val={euro(partnerMrr)} label="MRR gestito dai partner" />
        </div>

        <div className="rs-table parts">
          <div className="rs-thead">
            <span>Spazio</span>
            <span className="num">Clienti</span>
            <span className="num rs-hide-sm">MRR gestito</span>
            <span className="num">Da seguire</span>
          </div>
          {workspaces.map((w) => {
            const cs = clients.filter((c) => c.workspaceId === w.id);
            const mrr = cs.reduce((s, c) => s + c.mrr, 0);
            const flagged = cs.filter((c) => c.health !== 'good' || !c.setupPaid).length;
            return (
              <button type="button" className="rs-row" key={w.id} onClick={() => enter(w.id)}>
                <span className="rs-cli">
                  <span className="rs-av" style={{ width: 38, height: 38, '--av': w.accent } as CSSProperties} aria-hidden="true">
                    {w.mono}
                  </span>
                  <span style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                    <span className="rs-cli-name">
                      {w.name}
                      {w.house && <span className="rs-tag-house">house</span>}
                    </span>
                    <span className="rs-cli-meta">{w.house ? 'Clienti diretti di Ruben' : `Partner · dal ${shortDate(w.since)}`}</span>
                  </span>
                </span>
                <span className="rs-cell num">{cs.length}</span>
                <span className="rs-cell num rs-hide-sm">{mrr ? euro(mrr) : <span className="rs-dim">—</span>}</span>
                <span className="rs-cell num">
                  {flagged ? <span className="rs-flag">{flagged}</span> : <span className="rs-dim">—</span>}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

function Kpi({ icon, val, label }: { icon: IconName; val: string; label: string }) {
  return (
    <div className="kpi">
      <div className="kpi-top">
        <span className="kpi-ico">
          <Icon name={icon} size={17} />
        </span>
      </div>
      <span className="kpi-val">{val}</span>
      <span className="kpi-label">{label}</span>
    </div>
  );
}
